<template>
  <div class="home general" v-on:scroll="onScroll">
    <h1 class="section-title">
      Lista de Webhooks
    </h1>

    <va-data-table
        class="ekitable"
        :items="webhooks"
        :columns="columns"
        clickable
        no-data-html="<div class='no-data'>Cargando pistas...</div>"
        :sticky-header="true"
        :loading="false"
        allow-create
        loading-text=""
    >
      <template #headerPrepend>
        <tr>
          <th colspan="6">
            <va-input class="search-bar" title="Buscar Canciones" v-title placeholder="¿Qué cliente buscas (correo)?" v-on:keyup.enter="onEnter" v-on:focusout="onEnter" v-model="search">
              <template #prependInner>
                <font-awesome-icon :icon="['fa-solid', 'search']" />
              </template>
            </va-input>
          </th>
        </tr>
      </template>
      <template #cell(orderDate)="{ rowData }">
        {{ rowData.orderDate ? rowData.orderDate.substring(0,10) : '' }}
      </template>

      <template #cell(customer)="{ rowData }">
        <span v-if="rowData.registerFinishedAt">{{rowData.webhookUserLicense?rowData.webhookUserLicense.userLicenseUserInfo.fullname:''}}</span>
        <span v-else>Licencia sin activación</span>
      </template>

      <template #cell(actions)="{ rowData }">
        <va-button
            color="info"
            @click="clickAction('send',rowData.id)"
            v-if="!rowData.registerFinishedAt"
            title="Reenviar correo de activación"
            v-title
        >
          <font-awesome-icon :icon="['fa-solid', 'envelope-open']" />
        </va-button>
        <va-button
            color="info"
            @click="clickAction('copy',rowData.id)"
            v-if="!rowData.registerFinishedAt"
            class="ml-2"
            title="Copiar link de activación"
            v-title
        >
          <font-awesome-icon :icon="['fa-solid', 'copy']" />
        </va-button>

        <va-button
            color="info"
            @click="showConfirm(rowData)"
            v-if="!rowData.registerFinishedAt && !rowData.isCatalogUpdate"
            class="ml-2"
            title="Activar licencia"
            v-title
        >
          <font-awesome-icon :icon="['fa-solid', 'arrow-up-from-bracket']" />
        </va-button>

        <va-button
            color="info"
            @click="showMovePurchase(rowData)"
            v-if="rowData.canMoveUpdate"
            class="ml-2"
            title="Mover compra pagada"
            v-title
        >
          <font-awesome-icon :icon="['fa-solid', 'right-left']" />
        </va-button>

        <va-button
            color="info"
            v-if="rowData.registerFinishedAt!==null && rowData.webhookUserLicense!==null"
            @click="showConfirmReasign(rowData)"
            class="ml-2"
            title="Reasignar licencia"
            v-title
        >
          <font-awesome-icon :icon="['fa-solid', 'retweet']" />
        </va-button>
      </template>
    </va-data-table>
    <VaModal
                    v-model="showModal"
                    ok-text="Aceptar"
                    cancelText="cancelar"
                    @ok="activateLicence"
                >
                <h3 class="va-h3">
                   ¿Activar Licencia?
                </h3>
                <p>
                    ¿Seguro activar la licencia del correo {{licenseEmail}}?
                </p>
               
                </VaModal>


                <VaModal
                    v-model="showModalReasing"
                    ok-text="Aceptar"
                    cancelText="cancelar"
                    @ok="reasignLicence"
                >
                <h3 class="va-h3">
                   ¿Reasignar Licencia?
                </h3>
                <p>
                    ¿Seguro reasignar la licencia del correo {{licenseEmail}}? Ingresa el nuevo correo de activación. 
                    Para reasignar la licencia, el nuevo cliente debe tener una cuenta creada en la aplicación.
                </p>
                <va-input
                        v-model="reasingEmail"
                        placeholder="Ingresa un correo"
                        style="width: 100%;"
                    />
               
                </VaModal>

    <VaModal
        v-model="showModalMove"
        hide-default-actions
    >
      <h3 class="va-h3">Mover compra pagada</h3>
      <p>
        Actualización de {{ moveWebhook ? moveWebhook.email : '' }}. Elige la cuenta que ya tiene la licencia principal.
      </p>
      <va-input
          v-model="customerSearch"
          placeholder="Busca por correo o nombre"
          style="width: 100%;"
          v-on:keyup.enter="searchCustomers"
      />
      <va-button class="mt-2" color="info" :loading="searchingCustomers" @click="searchCustomers">Buscar</va-button>
      <div class="customer-results">
        <button
            type="button"
            class="customer-option"
            v-for="customer in customerResults"
            :key="customer.id"
            :class="{ selected: selectedCustomer && selectedCustomer.id === customer.id }"
            @click="selectCustomer(customer)"
        >
          {{ customer.fullname }} — {{ customer.email }}
        </button>
      </div>
      <p v-if="preview">
        {{ preview.email }} pasa de {{ preview.currentPackage }} a {{ preview.nextPackage }} canciones
      </p>
      <p v-if="moveError">{{ moveError }}</p>
      <div class="move-actions">
        <va-button color="secondary" @click="showModalMove = false">Cancelar</va-button>
        <va-button class="ml-2" color="info" :disabled="!preview || moving" :loading="moving" @click="movePaidUpdate">Mover compra</va-button>
      </div>
    </VaModal>
  </div>
  
</template>
<script>
import requester from "@/services/requester";
import { useToast } from 'vuestic-ui'
const { init, close, closeAll } = useToast()

export default {
  data() {
    return {
      page: 1,
      isLoading:false,
      webhooks:[],
      continueLoading: true,
      search:'',
      columns:[
        {key: 'email', sortable: false, label: 'correo de compra'},
        {key: 'event', sortable: false, label: 'evento'},
        {key: 'orderDate', sortable: false, label: 'fecha de compra'},
        {key: 'productName', sortable: false, label: 'Nombre de licencia'},
        {key: 'customer', sortable: false, label: 'Nombre del cliente'},
        {key: 'webhookUserLicense.userLicenseUserInfo.email', sortable: false, label: 'correo de activación'},
        {key: 'actions', sortable: false, label: 'Acciones'}

      ],
      showModal: false,
      licenseEmail:'',
      activateLicenseId:null,
      showModalReasing: false,
      reasingEmail:'',
      showModalMove: false,
      moveWebhook: null,
      customerSearch: '',
      customerResults: [],
      selectedCustomer: null,
      preview: null,
      moveError: '',
      moving: false,
      searchingCustomers: false
    }
  },
  methods: {
    onEnter() {
      this.page = 1;
      this.getFromApi();
    },
    async getFromApi(isScroll = false){
      this.isLoading = true;

      const data = await requester.Get(`/get-webhooks/${this.page}/?search=${this.search}`, true);

      console.log(data.data.webhooks);

      if (data.status === 200) {
        if(!isScroll) {
          this.webhooks = data.data.webhooks;
        }else{
          this.webhooks = this.webhooks.concat(data.data.webhooks);
        }
        if(data.data.webhooks.length>0) {
          this.page++;
          this.continueLoading = true;
        }
        else{
          this.continueLoading = false;
        }
      }
      this.isLoading = false;
    },
    onScroll(event) {
      if(!this.continueLoading){
        return;
      }
      if (!this.isLoading) {
        const {target} = event;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
          this.getFromApi(true);
        }
      }
    },
    async clickAction(action,id){
      try{
        const data = await requester.Get(`/get-action/${id}/${action}`, true);
        switch (action){
          case 'send':
            init('Correo enviado');
            break;
          case 'copy':
            await navigator.clipboard.writeText(data.data);
            init('Link copiado al portapapeles');
            break;
        }
        setTimeout(()=>{
          closeAll();
        },5000);
      }
      catch(e){

      }

    },
    async showConfirm(rowData){
      this.licenseEmail = rowData.email;
      this.activateLicenseId = rowData.id;
      this.showModal = true;
    },
    async activateLicence(){
      try{
        const data = await requester.Post(`/activate-license/${this.activateLicenseId}`, true);
        init('Licencia activada');
        this.showModal = false;
        setTimeout(()=>{
          closeAll();
          window.location.reload();
        },5000);
      }
      catch(e){

      }
    },
    async showConfirmReasign(rowData){
      this.licenseEmail = rowData.email;
      this.activateLicenseId = rowData.id;
      this.showModalReasing = true;
    },

    showMovePurchase(rowData) {
      this.moveWebhook = rowData;
      this.customerSearch = '';
      this.customerResults = [];
      this.selectedCustomer = null;
      this.preview = null;
      this.moveError = '';
      this.showModalMove = true;
    },
    async searchCustomers() {
      this.searchingCustomers = true;
      this.moveError = '';
      try {
        const data = await requester.Get(`/get-customers/1/?search=${encodeURIComponent(this.customerSearch)}`, true);
        this.customerResults = data.status === 200 ? data.data.customers : [];
      }
      catch (e) {
        this.moveError = 'No se pudo buscar clientes';
      }
      this.searchingCustomers = false;
    },
    async selectCustomer(customer) {
      this.selectedCustomer = customer;
      this.preview = null;
      this.moveError = '';
      try {
        const data = await requester.Post(`/preview-paid-update/${this.moveWebhook.id}`, true, { userId: customer.id });
        this.preview = data.data;
      }
      catch (e) {
        this.moveError = this.requestMessage(e, 'Esta cuenta no puede recibir la actualización');
      }
    },
    async movePaidUpdate() {
      if (!this.preview || !this.selectedCustomer || !this.moveWebhook) {
        return;
      }
      this.moving = true;
      this.moveError = '';
      try {
        await requester.Post(`/move-paid-update/${this.moveWebhook.id}`, true, { userId: this.selectedCustomer.id });
        init('Compra movida');
        this.showModalMove = false;
        setTimeout(() => {
          closeAll();
          window.location.reload();
        }, 1500);
      }
      catch (e) {
        this.moveError = this.requestMessage(e, 'No se pudo mover la compra');
      }
      this.moving = false;
    },
    requestMessage(error, fallback) {
      const data = error && error.response && error.response.data;
      if (data && data.message) {
        return data.message;
      }
      return fallback;
    },
    async reasignLicence(){
      try{
        const data = await requester.Post(`/reasign-license/${this.activateLicenseId}`, true,{email:this.reasingEmail});
        init('Licencia reasignada');
        this.showModal = false;
        setTimeout(()=>{
          closeAll();
          window.location.reload();
        },5000);
      }
      catch(e){
        init('no se pudo reasignar lal licencia');
      }
    },


  },
  created() {
    this.onEnter();
  },
  
}
</script>
<style scoped>
.customer-results {
  margin-top: 12px;
  max-height: 220px;
  overflow: auto;
}
.customer-option {
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 6px;
  padding: 8px;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
}
.customer-option.selected {
  border-color: #154ec1;
}
.move-actions {
  margin-top: 12px;
}
</style>